import { render } from "./SearchUidOrPhone.vue?vue&type=template&id=11d81a7f&scoped=true"
import script from "./SearchUidOrPhone.vue?vue&type=script&lang=js"
export * from "./SearchUidOrPhone.vue?vue&type=script&lang=js"

import "./SearchUidOrPhone.vue?vue&type=style&index=0&id=11d81a7f&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d81a7f"]])

export default __exports__